import React from "react";
import { FaTag } from "react-icons/fa";
import styles from "./GiftTagAdvice.module.css";
import commonStyles from "../../Shared/commonStyles.module.css";

function GiftTagAdvice() {
  const giftTagAdvice = [
    {
      title: "INCLUDE NAMES",
      description:
        "State who the gift is for, whether that is an individual, couple, family, or group. Use correct spellings and capitalise the names.",
      icon: <FaTag className={styles.TagIcon} />,
    },
    {
      title: "YOUR MESSAGE",
      description:
        "Keep your message short and heartfelt. In a brief note, explain why you’re giving this gift.",
      icon: <FaTag className={styles.TagIcon} />,
    },
    {
      title: "YOUR NAME",
      description:
        "Ever received a present and you don’t know who it’s from? It is crucial to include every name which might be yours, your family, etc. ",
      icon: <FaTag className={styles.TagIcon} />,
    },
    {
      title: "CHECK SPELLINGS",
      description:
        "Before you submit, check your message and spellings. Need inspiration? Message us for suggestions on wording.",
      icon: <FaTag className={styles.TagIcon} />,
    },
  ];

  return (
    
    <div className={`${commonStyles.card} ${styles.GiftTagAdvice}`}>
      <div className={commonStyles.sectionHeaderContainer}>
        <h3 className={commonStyles.sectionHeader}>Gift Tag Advice</h3>
        <p className={commonStyles.paragraph}>Simple steps for writing your gift tag message.</p>
        <div className={commonStyles.cards4}>            
          {giftTagAdvice.map((option, index) => (
            <div key={index} className={`${styles.GiftTagAdviceOption} ${commonStyles.card}`}>
              <h4>{option.title}</h4>
              {option.icon}
              <p>{option.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
    
  );
}

export default GiftTagAdvice;
